<template>
    <app-layout-main :title="`Edit File - ${form.copyright_text}`">

        <template v-slot:left-area>
            <div class="mb-5 p-2">
                <div class="search-wrapper">
                   <input class="input-black" type="text" placeholder="Search object...">
                   <i class="search"></i>
                </div>
            </div>
        </template>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">Edit file - {{ form.copyright_text }}</h3>

            <div class="grid grid-cols-1 md:grid-cols-2 my-2">
                <div class="">
                    <div class="flex">
                        <label for="file_type">Select file type</label>
                        <span v-if="errors.file_type" class="errormessage">{{ errors.file_type }}</span>
                    </div>
                <select class="select-black" id="file_type" disabled>
                    <option :value="form.file_type">{{ form.file_type }}</option>
                </select>
                </div>
            </div>


            <div class="flex">
                <label>File</label>
            </div>
            <div v-if="isImage(file)" class="upload-box overflow-hidden w-310px">
                <img class="object-cover w-full h-full" :src="isImage(file)" />
            </div>

            <div v-if="isAudio(file)" class="overflow-hidden">
                <audio controls>
                  <source :src="isAudio(file)" type="audio/mpeg">
                Your browser does not support the audio element.
                </audio>
            </div>

            <div v-if="isVideo(file)" class="overflow-hidden">
                <video width="400" controls>
                  <source :src="isVideo(file)" type="video/mp4">
                  Your browser does not support HTML video.
                </video>
            </div>

            <div v-if="is3dObject(file)" class="">
                  <a :href="is3dObject(file)" class="btn btn-gradient">Download</a>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-2 my-2">
                <div class="">
                    <div class="flex">
                        <label for="copyright_text">Copyright text</label>
                        <span v-if="errors.copyright_text" class="errormessage">{{ errors.copyright_text }}</span>
                    </div>
                    <input class="input-black" type="text" id="copyright_text" v-model="form.copyright_text">
                </div>
                <div class="">
                    <div class="flex">
                        <label for="copyright_link">Copyright link</label>
                        <span v-if="errors.copyright_link" class="errormessage">{{ errors.copyright_link }}</span>
                    </div>
                    <input class="input-black" type="text" id="copyright_link" v-model="form.copyright_link">
                </div>

                <div v-if="form.file_type == 'Marker'">
                    <div class="flex">
                        <label for="physical_width">Physical width (in cm.)</label>
                        <span v-if="errors.physical_width" class="errormessage">{{ errors.physical_width }}</span>
                    </div>
                    <input class="input-black" type="number" id="physical_width" v-model="form.physical_width">
                </div>

                <div v-if="form.file_type == 'Chromavideo'">
                    <div class="flex">
                        <label for="physical_width">Color</label>
                        <span v-if="errors.color" class="errormessage">{{ errors.color }}</span>
                    </div>
                    <input type="color" id="color" v-model="form.color">
                </div>

                <div v-if="form.file_type == 'Chromavideo'">
                    <div class="flex">
                        <label for="physical_width">Threshold percentage</label>
                        <span v-if="errors.threshold_percentage" class="errormessage">{{ errors.threshold_percentage }}</span>
                    </div>
                    <input class="input-black" type="number" min="0" max="100" id="threshold_percentage" v-model="form.threshold_percentage">
                </div>

            </div>

            <div class="block text-center">
                <button class="btn btn-gradient" @click="updateFile">
                    <i class="save mr-1"></i>Update
                </button>
                <span v-if="form.recentlySuccessful" class="ml-3 text-white">Updated</span>
            </div>

        </section>
    </app-layout-main>
</template>

<script>
import AppLayoutMain from '@/Layouts/AppLayoutMain.vue'
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayoutMain,
        Link,
    },
    props: {
      errors: Object,
    },
    mounted(){
        this.form.id = this.$page.props.file.data.id;
        this.form.path = this.$page.props.file.data.path;
        this.form.file_type = this.setFileType(this.$page.props.file.data.object_type);
        this.form.copyright_text = this.$page.props.file.data.copyright_text;
        this.form.copyright_link = this.$page.props.file.data.copyright_link;
        this.form.physical_width = this.$page.props.file.data.metaData.physical_width;
        this.form.color = this.$page.props.file.data.metaData.color;
        this.form.threshold_percentage = this.$page.props.file.data.metaData.threshold_percentage;
    },
    data() {
        return {
            file: this.$page.props.file.data,
            form: this.$inertia.form({
                _method: 'POST',
                id: null,
                path: '',
                file_type: '',
                copyright_text: '',
                copyright_link: '',
                physical_width: '',
                color: '',
                threshold_percentage: '',
            })
        }
    },
    methods: {
        updateFile() {
            this.form.put(route('media.update', this.form.id), {
                preserveScroll: true,
            });
        },
        setFileType(object_type){
            switch (object_type) {
            case 'file_meta_data_image':
                return 'Image';
                break;
            case 'file_meta_data_audio':
                return 'Audio';
                break;
            case 'file_meta_data_video':
                return 'Video';
                break;
            case 'file_meta_data_panorama_image':
                return 'Panorama image';
                break;
            case 'file_meta_data_panorama_video':
                return 'Panorama video';
                break;
            case 'file_meta_data_chroma_video':
                return 'Chromavideo';
                break;
            case 'file_meta_data_three_dimensional_object':
                return '3d Object';
                break;
            case 'file_meta_data_marker':
                return 'Marker';
                break;
            }
        },
        isImage(file){
            const object_type = file.object_type;
            if(object_type == 'file_meta_data_image' || object_type == 'file_meta_data_panorama_image'
                || object_type == 'file_meta_data_marker'){
                return file.path.includes('http') ? file.path : '/'+file.path;
            }
            return false
        },
        isAudio(file){
            const object_type = file.object_type;
            if(object_type == 'file_meta_data_audio'){
                return file.path.includes('http') ? file.path : '/'+file.path;
            }
            return false
        },
        isVideo(file){
            const object_type = file.object_type;
            if(object_type == 'file_meta_data_chroma_video' || object_type == 'file_meta_data_panorama_video'
                || object_type == 'file_meta_data_video'){
                return file.path.includes('http') ? file.path : '/'+file.path;
            }
            return false
        },
        is3dObject(file){
            const object_type = file.object_type;
            if(object_type == 'file_meta_data_three_dimensional_object'){
                return file.path.includes('http') ? file.path : '/'+file.path;
            }
            return false
        }
    }
}
</script>
